import type { Project } from 'src/data/project';

import { BLOG_DRAFT_STATUS } from './const';
import type { BlogDraft } from './types';

export const getBlogProjectEditingDrafts = (project: Project): BlogDraft[] =>
  filterEditingDrafts(project?.blogPostBuilderDrafts || []);

export const filterEditingDrafts = (drafts: BlogDraft[]): BlogDraft[] =>
  drafts
    .filter((draft) => draft.status === BLOG_DRAFT_STATUS.editing)
    .sort((a, b) => (a.draftId || 0) - (b.draftId || 0));
